import { drmCreateTableData } from "../../service/drmCreateTableData";
import {
  setCreateDrmTableDataSuccess,
  setCreateDrmTableDataFailure,
} from "../reducers/drmCreateTableDataSlice";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerCreateDrmTableData(action) {
  const { payload } = action;

  // Transform the payload to match the expected API format
  const bidDetails = payload.createTableData.map((row) => {
    const filteredRow = {
    ...row,
    carrierScac: row?.carrierScac || "",
    serviceScac: row?.serviceScac || "",
    tariffNumber: row?.tariffNumber || "",
    tariffId: row?.tariffId || "",
    orgHub: row?.orgHub || "", // MISSING IN SOURCE
    originZone: row?.originZone || "",
    originZoneDesc: row?.originZoneDesc || "",
    originZoneShortDesc: row?.originZoneShortDesc || "",
    originCity: row?.originCity || "",
    originState: row?.originState || "",
    originCountry: row?.originCountry || "",
    destHub: row?.destHub || "",
    destinationZone: row?.destinationZone || "",
    destinationZoneDesc: row?.destinationZoneDesc || "",
    destinationZoneShortDesc: row?.destinationZoneShortDesc || "",
    destinationCity: row?.destinationCity || "",
    destinationState: row?.destinationState || "",
    destinationCountry: row?.destinationCountry || "",
    region: row?.region || "",
    carrierManager: row?.carrierManager || "",
    miles: row?.miles || "",
    orderType: row?.orderType || "",
    primaryCustomers: row?.primaryCustomers || "",
    equipmentType: row?.equipmentType || "",
    laneDescription: row?.laneDescription || "",
    lineHaulChargeType: row?.lineHaulChargeType || "",
    btfRate: row?.btfRate || "",
    rate: row?.rate || "",
    //lineHaulRate: row?.lineHaulRate || "", // MISSING IN SOURCE
    awardBackup: row?.awardBackup || "",
    effectiveDate: row?.effectiveDate || "",
    expirationDate: row?.expirationDate || "",
    //bucketType: row?.bucketType || "", // MISSING IN SOURCE
    qtyActiveFlag: row?.qtyActiveFlag || "",
    qtyStartDate: row?.qtyStartDate || "",
    qtyEndDate: row?.qtyEndDate || "",
    minShipmentsAllocated: row?.minShipmentsAllocated || "",
    maxShipmentsAllocated: row?.maxShipmentsAllocated || "",
    percentageActiveFlag: row?.percentageActiveFlag || "",
    pctStartDate: row?.pctStartDate || "",
    pctEndDate: row?.pctEndDate || "",
    minCarrierAllocationPercentage: row?.minCarrierAllocationPercentage || "",
    maxCarrierAllocationPercentage: row?.maxCarrierAllocationPercentage || "",
    modeOfTransport: row?.modeOfTransport || "",
    changeComment: row?.changeComment || "",
    item: row?.item || "",
    itemType: row?.itemType || "",
    originTransportationMode: row?.originTransportationMode || "",
    originPort: row?.originPort || "",
    destinationTransportationMode: row?.destinationTransportationMode || "",
    destinationPort: row?.destinationPort || "",
    destinationPortCountry: row?.destinationPortCountry || "",
    tradeLane: row?.tradeLane || "",
    originPostalCode: row?.originPostalCode || "",
    destinationPostalCode: row?.destinationPostalCode || "",
    baf: row?.baf || "",
    civa: row?.civa || "",
    ets: row?.ets || "",
    qtyBucketType: row?.qtyBucketType || "",
    pctBucketType: row?.pctBucketType || "",
    coupaFileRecordErrors: Array.isArray(row?.coupaFileRecordErrors) ? row.coupaFileRecordErrors : [],
  };
    return filteredRow;
  });

  const createTableDataList = {
    coupaFileId: null,
    bidDetails,
  };

  try {
    const tableName = payload.tableName;
    const response = yield call(drmCreateTableData, [
      createTableDataList,
      tableName,
      payload.controller,
    ]);

    if (response?.status === 200) {
      yield put(setCreateDrmTableDataSuccess(response.data.message));
    } else {
      yield put(setCreateDrmTableDataFailure(response.status));
    }
  } catch (error) {
    yield put(setCreateDrmTableDataFailure(error.toString()));
  }
}

function* drmCreateTableDataSaga() {
  yield takeLatest("createDrmTable/setCreateDrmTableData", workerCreateDrmTableData);
}

export default drmCreateTableDataSaga;